export default __webpack_public_path__ + "static/media/skull_colour.eaa032e3.jpg";